// fitaf Design: Bootstrap-Datentabellen app-weit responsiv machen.
//
// Wrappt jede .table / .table-sm / .table-bordered in einen scrollbaren
// .table-responsive-Container, sofern sie nicht bereits responsiv ist.
// Dadurch scrollen breite Tabellen auf schmalen Screens horizontal, statt
// das Layout zu sprengen. Die Funktion ist idempotent (mehrfaches Ausfuehren
// bei Turbolinks-Navigation aendert nichts).
function wrapResponsiveTables() {
  var tables = document.querySelectorAll('table.table, table.table-sm, table.table-bordered');
  Array.prototype.forEach.call(tables, function (table) {
    if (table.classList.contains('table-responsive')) return; // bereits am Table markiert
    var parent = table.parentElement;
    if (!parent || parent.classList.contains('table-responsive')) return; // bereits gewrappt
    var wrapper = document.createElement('div');
    wrapper.className = 'table-responsive';
    parent.insertBefore(wrapper, table);
    wrapper.appendChild(table);
  });
}

document.addEventListener('turbolinks:load', wrapResponsiveTables);
